import { useDispatch, useSelector } from 'react-redux'
import { HiMoon, HiSun } from 'react-icons/hi'
import { toggleTheme } from './theme.slice'
import Switch from '../Basics/Switch'
import {
  SettingControl,
  SettingDescription,
  SettingIcon,
  SettingInfo,
  SettingRow,
  SettingText,
  SettingTitle,
} from './ThemeSwitcher.styles'

const ThemeSwitcher = () => {
  const dispatch = useDispatch()
  const theme = useSelector(state => state.theme.theme)
  const isDark = theme === 'dark'

  const handleTheme = () => {
    dispatch(toggleTheme())
  }

  return (
    <SettingRow>
      <SettingInfo>
        <SettingIcon aria-hidden>
          {isDark ? <HiMoon /> : <HiSun />}
        </SettingIcon>
        <SettingText>
          <SettingTitle>Modo oscuro</SettingTitle>
          <SettingDescription>
            {isDark
              ? 'El panel está usando el tema oscuro.'
              : 'El panel está usando el tema claro.'}
          </SettingDescription>
        </SettingText>
      </SettingInfo>
      <SettingControl>
        <Switch
          checked={isDark}
          onChange={handleTheme}
          ariaLabel="Activar modo oscuro"
        />
      </SettingControl>
    </SettingRow>
  )
}

export default ThemeSwitcher
